var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('groups',{attrs:{"groups":_vm.faqGroups,"selected-group":_vm.selectedGroup},on:{"group-selected":_vm.setSelectedGroup}}),_vm._v(" "),_vm._l((_vm.selectedGroupFAQs),function(faq){return _c('div',{key:faq.Id},[_c('faq',{attrs:{"faq":faq,"selected-faq":_vm.selectedFaq},on:{"faq-selected":_vm.setSelectedFaq}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-020de230","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/grad-images/home/faq/App.vue
// module id = 1661
// module chunks = 24